import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/ConductorLicensePage.head';
import { ConductorLicensePage } from '@pages/ConductorLicensePage';

export const Route = createFileRoute('/conductor-license')({
  component: ConductorLicensePage,
  head: () => head,
});
